<!-- section start -->
<ng-template #postcodeModal let-c="close" class="modal-dialog-centered" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Confirm Postcode</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <form class="form">
      <div class="form-group" [formGroup]="postcodeForm">
        <h5>Note: Delivery charges (if required) will be calculated from this postcode,
          if an invalid postcode is given, you may be asked to pay more before we
        dispatch goods</h5>
        <label for="name">Delivery Postcode</label>
        <div class="input-group">
          <input class="form-control" placeholder="Delivery Postcode"
            id="postcode"
            type="text"
            formControlName="postcode">
        </div>
        <br />

        <!--
        <div class="form-check">
          <label for="clearance">Next Day Delivery</label>
          <input id="express" class="form-check-input" type="checkbox" formControlName="nextDay">
        </div>


        <div class="form-check">
          <label for="clearance">AM Drop</label>
          <input id="express" class="form-check-input" type="checkbox" formControlName="amDrop">
        </div>
        -->

        <br />

        <button class="btn btn-success" [disabled]="postcodeForm?.invalid"
        (click)="calculateViaAPI()">Calculate</button>

      </div>
    </form>


    <button type="button" class="btn btn-default primary-btn danger"
      (click)="c('Close click')">Close
    </button>

  </div>
</ng-template>

<section class="agency blog blog-sec blog-sidebar sider">
  <div class="container">
    <div class="row pl-0 pr-0">
         <div class="col-lg-12 blog-sec blog-list">
            <div class="row">
                <div class="text-center blog-list pl-0 pr-0 white-next">
                    <h3>ORDER BEFORE 12:00 for next-day delivery</h3>
                </div>
                
            </div>
        </div>
      <div class="col-lg-8">
        <div class="row">
          @for (item of basket; track item) {
            <div class="col-12 blog-sec blog-list">
              <div class="blog-agency">
                <div class="row blog-contain pl-0 pr-0">
                  <div class="col-xl-2 col-lg-3 col-md-4 p-0">
                    <div class=" text-center">
                      <img [src]="item.colourAWSURL"
                        alt="" class="img-fluid basket-img">
                    </div>
                  </div>
                  <div class="col-xl-10 col-lg-9 col-md-8 p-0">
                    <div class="img-container">
                      <div class="row">
                        <div class="col-xl-10 col-lg-9 col-md-8 ">
                          <div class="blog-info">
                            <h5 class="blog-head font-600">{{item.productName}} <br /> {{item.colourName}}</h5>
                            @if (item.qtyWidth <= 1) {
                                @if(item.packSize !== 1) {
                                    <p>Pack Size: {{item.packSize}} m2</p>
                                }
                            }
                            <p>Your Order: {{calculateLineSize(item)}} m2</p>
                            <p> In Stock?
                              @if (checkStockObj(item) === false;) {
                                <fa-icon class="fa-lg redFA" size="lg" [icon]="faTimes"></fa-icon>
                              }
                              @if (checkStockObj(item) === true;) {
                                <fa-icon class="fa-lg greenFA" size="lg" [icon]="faCheck"></fa-icon>
                              }
                            <br /></p>
                            @if (checkStockObj(item) === false) {
                              <p>
                                Stock amount: {{checkStockStatus(item)}}<br />
                                <span class="form-error">We only have part of your order in stock, we will dispatch it
                                  when it is all available, if you wish to have it sooner, please reduce
                                your order to match our stock levels</span>
                              </p>
                            }
                            <div class="basketButtons">
                              <fa-icon  (click)="oneLessQty(item)" class="basket-icon-modify"
                                size="2x" [icon]="faMinus">
                              </fa-icon>
                              <input class="form-control checkouttotal" type="text"
                                value="{{item.qtyLength}}" readonly />
                              <fa-icon  (click)="oneMoreQty(item)"  class="basket-icon-modify"
                                size="2x" [icon]="faPlus">
                              </fa-icon>
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-2 col-lg-3 col-md-4 p-0">
                          <div class="blog-info">
                            <h5 class="blog-head font-600">Unit Pirce: £{{item.unitPrice}}</h5>
                            <p> Line value: £{{calculateLineValue(item)}}</p>
                            <div class="btn-bottom m-t-20">
                              <button (click)="removeCartItem(item)" class="btn btn-default primary-btn danger">
                                Remove
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="col-lg-4">
        <div class="theme-card">

          Total Ex VAT:
          <input class="form-control checkoutfinal" type="text"
            value="{{totalExVat| currency:'GBP'}}" readonly />
          @if (deliveryChecked === false) {
            <div>
              Delivery:
              <input class="form-control checkoutfinal" type="text"
                value="TBD" readonly />
            </div>
          }
          @if (deliveryChecked === true) {
            <div>
              Delivery:
              <input class="form-control checkoutfinal" type="text"
                value="{{delivery| currency:'GBP'}}" readonly />
            </div>
          }

          VAT:
          <input class="form-control checkoutfinal" type="text"
            value="{{totalVat| currency:'GBP'}}" readonly />
          Total:
          <input class="form-control checkoutfinal" type="text"
            value="{{fullTotal| currency:'GBP'}}" readonly />
          <div class="basket-buttons text-center">
            <button class="btn btn-default primary-btn success" (click)="getDeliveryQuote()">
              Calculate Delivery
            </button>

            @if (deliveryError !== null) {
              <h3 class="form-error">ERROR!! {{deliveryError}} <br /></h3>
            }

            <a [routerLink]="['/express/checkout']">
              <button class="btn btn-default primary-btn info"
                (click)="proceedCheckout()"
                [disabled]="!deliveryChecked">
                Checkout
              </button>
            </a>
          </div>
        </div>

        <div class="theme-card">
          <h4>Own brand ranges of carpets, vinyls & LVT are delivered FREE nationwide.</h4>
        </div>


        <div class="theme-card">
          <h6>*Some postcodes and heavy products (such as glue/screed) may carry a delivery surcharge, all orders under £100 have a £10 charge.</h6>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- section end -->